import React from 'react';

class NoContent extends React.Component {
  render() {
    return (
      <div className="block-no-content" style={{height: this.props.height}}>
        <div className='Icon-Folder'></div>
        <p className='block-no-content-desc'>{this.props.content}</p>
      </div>
    );
  }
}

NoContent.defaultProps = {
  content: 'Bạn chưa có dữ liệu ở trang này',
  height: 647
};

export default NoContent;



// WEBPACK FOOTER //
// ./components/utils/NoContent.jsx